import firebase from 'firebase';
import _ from 'lodash';

export const getWorkorderCategories = async (id) => {
  const result = [];
  let req = null;

  req = myFirestore
    .collection('projects')
    .doc(id)
    .collection('workorder-categories')
    .orderBy("index", 'asc');

  const data = await req.get();

  data.forEach((subDoc) => {
    const data = subDoc.data();
    result.push({
      label: data.name || '',
      value: subDoc.id,
      id: subDoc.id || null,
    });
  });

  return [..._.orderBy(result, '_data.index', ['desc'])];
};



export const getOptionsWorkorderCategories = async (id) => {
  const result = [{label: 'Все категории', value: null}];

  const categories = await getWorkorderCategories(id);

  return [...result, ...categories];
}



// WEBPACK FOOTER //
// ./src/firestore/workorder-categories.js